
import DBFunctions from '@/common/DBFunctions.js'
import Utils from '@/common/utils.js'
import StorageService from '@/services/storage.service'

export default {
    mixins: [DBFunctions],

    data() {
        return {
            permissions: [],
            leftMenu: this.$store.state.leftMenu,
            checkBeforeRouteEnter: '',
            beforeRouteCondition: true
        }
    },

    methods: {
        CanViewAllowed() {
            if (!this.DisabledBySetting()) {
                return this.permissions.length !== 0 && this.permissions[0].roleCanView;
            }

            return true;
        },

        CanAddAllowed() {
            if (!this.DisabledBySetting()) {
                return this.permissions.length !== 0 && this.permissions[0].roleCanAdd;
            }

            return true;
        },

        CanEditAllowed() {
            if (!this.DisabledBySetting()) {
                return this.permissions.length !== 0 && this.permissions[0].roleCanEdit;
            }

            return true;
        },

        CanDeleteAllowed() {
            if (!this.DisabledBySetting()) {
                return this.permissions.length !== 0 && this.permissions[0].roleCanDelete;
            }

            return true;
        },

        DisabledBySetting() {
            if (StorageService.IsSetupUser()) {
                return true;
            }
            
            return !this.$store.state.permissionEnabledBySetting;
        },

        InitializePermissions(checkBeforeRouteEnter, beforeRouteCondition) {
            this.checkBeforeRouteEnter = checkBeforeRouteEnter;
            this.beforeRouteCondition = beforeRouteCondition === undefined ? true : beforeRouteCondition;
            this.getPermissionLeftMenu(this.leftMenu, this.$route.path, this.permissions);
            return this.IsAccessAllowed();
        },

        IsAccessAllowed() {
            let accessAllow = true;
            if (!this.DisabledBySetting()) {
                switch (this.checkBeforeRouteEnter) {
                    case 'ListView': accessAllow = this.CanViewAllowed(); break;
                    case 'AddView': accessAllow = this.CanViewAllowed() && this.CanAddAllowed(); break;
                    case 'EditView': accessAllow = this.CanViewAllowed() && this.CanEditAllowed(); break;
                }
            }
            
            return accessAllow;
        }
    },

    beforeRouteEnter(to, from, next) {
        next(async vm => {
            let accessAllow = Utils.isNullOrEmptyString(vm.checkBeforeRouteEnter);
            if (!accessAllow) {
                accessAllow = vm.IsAccessAllowed();
            }

            if (accessAllow && vm.beforeRouteCondition) {
                next();
            } else {
                next('/accessdenied');
            }
        })
    },
}